import type { PositionPriceObject } from '@ab-core/graphql/dist/index';
import type { MoneyObject } from '@ab-core/types/src';
import type { FC } from 'react';
import React from 'react';
import { DiscountSum } from './discountSum';
import { ScalePrices } from './scalePrices';
import { Surcharges } from './surcharges';
import type { UvpProps } from './uvp';
import { Uvp } from './uvp';

export type PricesStylesType = {
    pricesStyles?: {
        isVisible?: boolean;
        uvp: Pick<UvpProps, 'showUvpWithVat' | 'showUvpWithoutVat'>;
        showSurcharges?: boolean;
        showScalePrices?: boolean;
    };
};

export type PricesType = PricesStylesType & {
    quantityUnit: string;
    salesUnit: number;
    positionPrice?: PositionPriceObject;
    quantity: number;
    cartId?: string;
    sku: string;
    hidePrice?: boolean;
};

export const Prices: FC<PricesType> = (props) => {
    const { salesUnit, quantityUnit, positionPrice, quantity, pricesStyles, cartId, sku, hidePrice } = props;

    if (pricesStyles?.isVisible === false) {
        return <></>;
    }

    return (
        <>
            {!!pricesStyles?.showScalePrices && (
                <ScalePrices
                    {...positionPrice}
                    quantityUnit={quantityUnit}
                    salesUnit={salesUnit}
                    quantity={quantity}
                    cartId={cartId}
                    sku={sku}
                />
            )}

            {!hidePrice && <Uvp {...positionPrice} {...pricesStyles?.uvp} />}
            {pricesStyles?.showSurcharges && !hidePrice && <Surcharges {...positionPrice} />}
            {(positionPrice?.discountSum?.centAmount || 0) > 0 && (
                <DiscountSum discountSum={positionPrice?.discountSum as MoneyObject} />
            )}
        </>
    );
};
